import { LegalPage } from "@/components/landing/LegalPage";

const sections = [
  {
    id: "principles",
    title: "Our security principles",
    body: (
      <>
        <p>Patient data is sacred. Clinic OS is designed around four non-negotiables:</p>
        <ul>
          <li><strong>Read-only EMR.</strong> We read from Jane / Juvonno. We never edit, never delete.</li>
          <li><strong>Encryption everywhere.</strong> TLS 1.3 in transit, AES-256 at rest. Zero exceptions.</li>
          <li><strong>Least privilege.</strong> Engineers access production data only when explicitly required, audited, and time-boxed.</li>
          <li><strong>Defence in depth.</strong> Network, application, and identity layers each enforce independent controls.</li>
        </ul>
      </>
    ),
  },
  {
    id: "compliance",
    title: "Compliance",
    body: (
      <ul>
        <li><strong>HIPAA-ready.</strong> Administrative, physical, and technical safeguards aligned with HIPAA Security &amp; Privacy Rules.</li>
        <li><strong>SOC 2 Type II</strong> audited annually for Security, Availability and Confidentiality.</li>
        <li><strong>PIPEDA</strong> compliant for Canadian patient data.</li>
        <li><strong>PHIPA</strong> aligned for Ontario clinical data handling.</li>
      </ul>
    ),
  },
  {
    id: "infrastructure",
    title: "Infrastructure",
    body: (
      <>
        <p>Clinic OS runs on enterprise-grade cloud infrastructure:</p>
        <ul>
          <li>Multi-AZ deployments on AWS &amp; Google Cloud (Canadian regions for Canadian customers).</li>
          <li>Automated backups every 15 minutes; daily snapshots retained for 30 days.</li>
          <li>Continuous vulnerability scanning of containers and dependencies.</li>
          <li>WAF + DDoS protection at the edge.</li>
        </ul>
      </>
    ),
  },
  {
    id: "access",
    title: "Access & authentication",
    body: (
      <ul>
        <li>SSO (Google Workspace, Microsoft 365) available on Hub+ and Sales Autopilot plans.</li>
        <li>MFA enforced on all admin accounts by default.</li>
        <li>Role-based access — owner, manager, clinician, reception scopes configurable per location.</li>
        <li>Session timeouts and device fingerprinting on sensitive routes.</li>
      </ul>
    ),
  },
  {
    id: "incident-response",
    title: "Incident response",
    body: (
      <p>
        We maintain a documented incident-response runbook, with on-call coverage 24/7. Customers are notified within 72 hours of confirmed incidents that affect their data. Postmortems are shared publicly on the Status page for material outages.
      </p>
    ),
  },
  {
    id: "responsible-disclosure",
    title: "Responsible disclosure",
    body: (
      <>
        <p>
          Found a vulnerability? Email <strong>security@clinicfirst.app</strong> with details and reproduction steps. We respond within one business day and credit valid reports in our hall of fame.
        </p>
        <p>
          We do not pursue legal action against researchers acting in good faith under our responsible disclosure terms.
        </p>
      </>
    ),
  },
];

export default function Security() {
  return (
    <LegalPage
      testId="security-page"
      kicker="Trust · security"
      title="Built to be"
      highlight="trusted."
      subtitle="The security posture, compliance certifications, and incident-response practices behind Clinic OS — written so a clinic owner can read them, not just an auditor."
      updated="Feb 2026"
      sections={sections}
    />
  );
}
